





















































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { authUserStore } from '@/utils/store-accessor'

@Component({
  components: {}
})
export default class CollectionContentTreeItemAction extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  notEditable!: boolean

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }
}
